import { SecurityNetworkIcon } from './SecurityNetworkIcon';

/**
 * author: Austin Andrews
 * id C9FA8517-7CD1-4AB7-86AD-0A2BF1016466
 * name security-network
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/security-network.svg
 * tags
 */
export const AdministratorNetworkIcon = SecurityNetworkIcon;
export default AdministratorNetworkIcon